// extracted by mini-css-extract-plugin
module.exports = {"title":"title__1S1za","attribute":"attribute__cPzCR","wrap":"wrap__z-PNZ","list":"list__NSDrj"};